<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      {{ $t("events.event-config.access-rules") }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-row v-if="isCommomOrCourtesy">
        <v-col cols="12">
          <BaseTextField
            required
            :label="$t('events.event-config.days-before')"
            :placeholder="$t('events.event-config.days-before-example')"
            type="number"
            min="0"
            :rules="[rules.requiredZero]"
            v-model.number="
              $produtos_gerenciar.cadastro.regra_acesso.dias_antes
            "
          />
        </v-col>
        <v-col cols="12">
          <BaseTextField
            required
            :label="$t('events.event-config.hours-before')"
            :placeholder="$t('events.event-config.hours-before-example')"
            type="number"
            min="0"
            max="24"
            :rules="[rules.requiredZero]"
            v-model.number="
              $produtos_gerenciar.cadastro.regra_acesso.horas_antes
            "
          />
        </v-col>
        <v-col cols="12">
          <BaseTextField
            required
            :label="$t('events.event-config.days-after')"
            :placeholder="$t('events.event-config.days-after-example')"
            type="number"
            min="0"
            :rules="[rules.requiredZero]"
            v-model.number="
              $produtos_gerenciar.cadastro.regra_acesso.dias_depois
            "
          />
        </v-col>
        <v-col cols="12">
          <BaseTextField
            required
            :label="$t('events.event-config.hours-after')"
            :placeholder="$t('events.event-config.hours-after-example')"
            type="number"
            min="0"
            max="24"
            :rules="[rules.requiredZero]"
            v-model.number="
              $produtos_gerenciar.cadastro.regra_acesso.horas_depois
            "
          />
        </v-col>
        <v-col cols="12">
          <BaseTextField
            required
            :label="$t('events.event-config.use-limit')"
            placeholder="Ex: 1"
            type="number"
            min="0"
            :rules="[rules.requiredZero]"
            v-model.number="
              $produtos_gerenciar.cadastro.regra_acesso.limite_uso
            "
          />
        </v-col>
        <v-col cols="12" v-if="isAdmin && storeHasElevenTicketsAccessInfo">
          <v-checkbox
            v-model="$produtos_gerenciar.cadastro.regra_acesso.circus"
            :label="$t('events.event-config.enable-eleven-access-integration')"
            class="py-0 my-0"
            hide-details
          >
          </v-checkbox>
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="$produtos_gerenciar.cadastro.regra_acesso.is_facial"
            :label="$t('events.event-config.enable-facial-recognition')"
            class="py-0 my-0"
            hide-details
          >
          </v-checkbox>
        </v-col>
        <v-col cols="12">
          <v-checkbox
            class="py-0 my-0"
            hide-details="auto"
            :label="$t('new-event.settings.inputs.bearer')"
            v-model="$produtos_gerenciar.cadastro.regra_acesso.portador"
          />
        </v-col>
      </v-row>
      <v-row v-if="isVoucherProduct">
        <v-col cols="12">
          <BaseTextField
            required
            :label="$t('events.event-config.days-after')"
            placeholder="Ex: 3"
            type="number"
            min="0"
            :rules="[rules.requiredZero]"
            v-model.number="
              $produtos_gerenciar.cadastro.regra_acesso.dias_depois
            "
          />
        </v-col>
        <v-col cols="12">
          <BaseTextField
            required
            :label="$t('events.event-config.use-limit')"
            placeholder="Ex: 1"
            type="number"
            min="0"
            :rules="[rules.requiredZero]"
            v-model.number="
              $produtos_gerenciar.cadastro.regra_acesso.limite_uso
            "
          />
        </v-col>
        <v-col cols="12" v-if="isAdmin && storeHasElevenTicketsAccessInfo">
          <v-checkbox
            v-model="$produtos_gerenciar.cadastro.regra_acesso.circus"
            :label="$t('events.event-config.enable-eleven-access-integration')"
            class="py-0 my-0"
            hide-details
          >
          </v-checkbox>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import mixins from "@/mixins";
import BaseTextField from "@/components/forms/BaseTextField.vue";

const { formRules } = mixins;

export default {
  name: "AccessRules",
  mixins: [formRules],
  components: {
    BaseTextField,
  },
  data: () => ({}),
  computed: {
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      return false;
    },
    isCommomOrCourtesy() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo ===
          "INGRESSO" ||
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "CORTESIA"
      );
    },
    isVoucherProduct() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "VOUCHER"
      );
    },
    storeHasElevenTicketsAccessInfo() {
      const elevenTicketsInfo = JSON.parse(
        localStorage.getItem("eleventickets_access")
      );

      if (
        elevenTicketsInfo?.token_circus !== null &&
        elevenTicketsInfo?.url_circus !== null &&
        this.isAdmin
      ) {
        return true;
      }

      return false;
    },
  },
  mounted() {
    if (this.$produtos_gerenciar.cadastro.regra_acesso.dias_antes === "") {
      this.$produtos_gerenciar.cadastro.regra_acesso.dias_antes = 0;
    }
    if (this.$produtos_gerenciar.cadastro.regra_acesso.horas_antes === "") {
      this.$produtos_gerenciar.cadastro.regra_acesso.horas_antes = 12;
    }
    if (this.$produtos_gerenciar.cadastro.regra_acesso.dias_depois === "") {
      this.$produtos_gerenciar.cadastro.regra_acesso.dias_depois = 0;
    }
    if (this.$produtos_gerenciar.cadastro.regra_acesso.horas_depois === "") {
      this.$produtos_gerenciar.cadastro.regra_acesso.horas_depois = 12;
    }
    if (this.$produtos_gerenciar.cadastro.regra_acesso.limite_uso === "") {
      this.$produtos_gerenciar.cadastro.regra_acesso.limite_uso = 1;
    }
  },
};
</script>

<style scoped></style>
